module.exports = __webpack_public_path__ + "static/img/katsuobushimushi_ka.2fa96ad.jpg";